'use strict';
'use client';
import { j as a } from "../../external/react/jsx-runtime.js";
import { useEffect as n } from "react";
import o from "../../assets/images/icons/apple.png.js";
const p = async (e, t) => {
  const i = {
    identityToken: e.authorization.id_token,
    authorizationCode: e.authorization.code
  };
  e.user && (i.fullName = {
    givenName: e.user.name.firstName,
    familyName: e.user.name.lastName
  }), t(i);
};
function l({ onLoginSuccess: e }) {
  return n(() => {
    const t = document.createElement("script");
    t.src = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js", t.type = "text/javascript", t.async = !0, t.onload = () => {
      window.AppleID.auth.init({
        clientId: process.env.NEXT_PUBLIC_APPLE_CLIENT_ID,
        scope: "name email",
        redirectURI: window.location.origin,
        usePopup: !0
      });
    }, document.body.appendChild(t);
  }, []), /* @__PURE__ */ a.jsx(a.Fragment, { children: /* @__PURE__ */ a.jsxs(
    "button",
    {
      className: "flex h-[40px] w-[300px] items-center justify-center gap-2 rounded border border-[#000] bg-[#000] p-4 font-demi text-white hover:bg-black sm:w-[400px]",
      type: "button",
      onClick: async () => {
        const t = await window.AppleID.auth.signIn();
        p(t, e);
      },
      children: [
        /* @__PURE__ */ a.jsx(
          "img",
          {
            className: "pb-1",
            src: o,
            width: 14,
            height: 13,
            alt: "Apple"
          }
        ),
        "Continue with Apple"
      ]
    }
  ) });
}
export {
  l as default
};
